import kSiteImage from '../../images/k-site.png';
import kVoteImage from '../../images/k-vote.png';
import weappImage from '../../images/weapp.png';
import kkdShopImage from '../../images/kkd-shop.png';
import officialAccountsImage from '../../images/official-accounts.png';
import cloudCommentImage from '../../images/cloud-comment.png';
import { StringObject } from '../../interface/base';
import { 
  SITE_LIST, 
  VOTE_LIST, 
  WEAPP_LIST, 
  KUAIKEDUO_SHOP_LIST,
  OFFICIAL_ACCOUNT_LIST, 
  CHANGYAN_BACK,
  SITE_UPGRADE,
  VOTE_UPGRADE,
  CHANGYAN_UPGRADE,
  WEAPP_UPGRADE
} from '../../constants/routes'
import { ILink } from '@components/Sider/interface';

export const serviceMaps: StringObject<{
  link?: ILink,
  unit: string,
  logo: string,
  desc: string,
  upgrade?: string,
  backendIcon?: string,
  backendText?: string,
  newVersion?: string
}> = {
  SITE: {
    unit: '站点',
    logo: kSiteImage,
    desc: '零门槛快速建站',
    upgrade: SITE_UPGRADE,
    backendIcon: 'site',
    backendText: '站点列表',
    link: { href: SITE_LIST, linkType: 'outer' }
  },
  VOTE: {
    unit: '投票',
    logo: kVoteImage,
    desc: '精确数据监控、智能手段防刷、满足多场景的专业投票创建平台',
    link: { href: VOTE_LIST, linkType: 'outer' },
    upgrade: VOTE_UPGRADE,
  },
  MP_APP: {
    unit: '小程序',
    logo: weappImage,
    desc: '快速获客，自由编辑，搭建专属小程序',
    link: { href: WEAPP_LIST, linkType: 'outer' },
    upgrade: WEAPP_UPGRADE,
  },
  KUAIKEDUO: {
    unit: '店铺',
    logo: kkdShopImage,
    desc: '专注于会员的电商SAAS平台',
    link: { href: KUAIKEDUO_SHOP_LIST, linkType: 'outer', isOpenNewWindow: true },
  },
  MP: {
    unit: '公众号',
    logo: officialAccountsImage,
    desc: '快速吸粉，高效管理',
    link: { href: OFFICIAL_ACCOUNT_LIST },
    // upgrade: SITE_UPGRADE,
    newVersion: '/v3/weixin/list'
  },
  CHANGYAN: {
    unit: '站点',
    logo: cloudCommentImage,
    desc: 'PC/WAP/APP轻松配置，实现智能评论管理',
    link: { href: CHANGYAN_BACK, linkType: 'outer', isOpenNewWindow: true },
    upgrade: CHANGYAN_UPGRADE
  }
}
